(($, Drupal) => {
  "use strict";

  Drupal.behaviors.questionModalLatexAnswerButtons = {
    attach: function (context) {
      const $latexDrupalInput = $(".latex-answer-drupal input", context);

      // Maths input
      if ($latexDrupalInput.length > 0) {
        // Build latex math input container dynamically
        $(".latex-wrapper", context)
          .once()
          .append(
            `<div class="latex-answer">
            <span class="math-input" id="math-input"></span>
            <button class="btn math-input-button">
              <span class="sr-only">Open symbols</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="24" viewBox="0 0 36 24">
                <path d="M33,28.5H3a3,3,0,0,1-3-3V7.5a3,3,0,0,1,3-3H33a3,3,0,0,1,3,3v18A3,3,0,0,1,33,28.5ZM8,11.75V9.25a.75.75,0,0,0-.75-.75H4.75A.75.75,0,0,0,4,9.25v2.5a.75.75,0,0,0,.75.75h2.5A.75.75,0,0,0,8,11.75Zm6,0V9.25a.75.75,0,0,0-.75-.75h-2.5a.75.75,0,0,0-.75.75v2.5a.75.75,0,0,0,.75.75h2.5A.75.75,0,0,0,14,11.75Zm6,0V9.25a.75.75,0,0,0-.75-.75h-2.5a.75.75,0,0,0-.75.75v2.5a.75.75,0,0,0,.75.75h2.5A.75.75,0,0,0,20,11.75Zm6,0V9.25a.75.75,0,0,0-.75-.75h-2.5a.75.75,0,0,0-.75.75v2.5a.75.75,0,0,0,.75.75h2.5A.75.75,0,0,0,26,11.75Zm6,0V9.25a.75.75,0,0,0-.75-.75h-2.5a.75.75,0,0,0-.75.75v2.5a.75.75,0,0,0,.75.75h2.5A.75.75,0,0,0,32,11.75Zm-21,6v-2.5a.75.75,0,0,0-.75-.75H7.75a.75.75,0,0,0-.75.75v2.5a.75.75,0,0,0,.75.75h2.5A.75.75,0,0,0,11,17.75Zm6,0v-2.5a.75.75,0,0,0-.75-.75h-2.5a.75.75,0,0,0-.75.75v2.5a.75.75,0,0,0,.75.75h2.5A.75.75,0,0,0,17,17.75Zm6,0v-2.5a.75.75,0,0,0-.75-.75h-2.5a.75.75,0,0,0-.75.75v2.5a.75.75,0,0,0,.75.75h2.5A.75.75,0,0,0,23,17.75Zm6,0v-2.5a.75.75,0,0,0-.75-.75h-2.5a.75.75,0,0,0-.75.75v2.5a.75.75,0,0,0,.75.75h2.5A.75.75,0,0,0,29,17.75Zm-21,6v-2.5a.75.75,0,0,0-.75-.75H4.75a.75.75,0,0,0-.75.75v2.5a.75.75,0,0,0,.75.75h2.5A.75.75,0,0,0,8,23.75Zm18,0v-2.5a.75.75,0,0,0-.75-.75H10.75a.75.75,0,0,0-.75.75v2.5a.75.75,0,0,0,.75.75h14.5A.75.75,0,0,0,26,23.75Zm6,0v-2.5a.75.75,0,0,0-.75-.75h-2.5a.75.75,0,0,0-.75.75v2.5a.75.75,0,0,0,.75.75h2.5A.75.75,0,0,0,32,23.75Z" transform="translate(0 -4.5)" fill="#0e5aff"/>
              </svg>
            </button>
          </div>
          <div class="latex-answer-buttons">
            ${Drupal.behaviors.questionModalLatexAnswerButtons.generateSymbolButtons()}
          </div>`
          );

        Drupal.behaviors.questionModalLatexAnswerButtons.initMathsInput(
          context
        );
      }
    },
    /**
     * Generate buttons for math symbols dynamically
     * @returns {string} HTML string of buttons
     */
    generateSymbolButtons: function () {
      const symbols = [
        { symbol: "=", icon: "symbol-equals" },
        { symbol: "+", icon: "symbol-plus" },
        { symbol: "-", icon: "symbol-minus" },
        { symbol: "\\times", icon: "symbol-multiply" },
        { symbol: "/", icon: "symbol-divide" },
        { symbol: "%", icon: "symbol-percentage" },
        { symbol: "(", icon: "symbol-parenth-a" },
        { symbol: ")", icon: "symbol-parenth-b" },
        { symbol: "&gt;", icon: "symbol-more" },
        { symbol: "&lt;", icon: "symbol-less" },
        { symbol: "\\geq", icon: "symbol-more-equal" },
        { symbol: "\\leq", icon: "symbol-less-equal" },
        { symbol: "\\frac{}{}", icon: "symbol-fraction" },
        { symbol: "\\sqrt{}", icon: "symbol-root" },
        { symbol: "^{}", icon: "symbol-super" },
        {
          symbol: "\\left(\\frac{}{}\\right)",
          icon: "symbol-fraction-parenth",
        },
      ];

      return symbols
        .map(
          ({ symbol, icon }) =>
            `<button class="btn latex-answer-buttons__button latex-answer-buttons__button--fraction" data-symbol="${symbol}">
              <span class="sr-only">Add symbol</span>
              <img width="40" height="40" src="/themes/custom/olex_ai/images/icons/${icon}.svg" alt="">
            </button>`
        )
        .join("");
    },
    /**
     * Init Maths quill library and symbols functionality.
     */
    initMathsInput: function (context) {
      const MQ = MathQuill.getInterface(2);
      MQ.config({
        autoOperatorNames: "sins",
      });
      // autoOperatorNames
      const answerMathFields = [];

      $(".latex-answer-drupal-input", context).each(function (key, value) {
        const $this = $(value);
        if (
          $this.closest("form").is(".form--english") &&
          $this.closest(".quiz-result-answer").length < 1
        ) {
          return;
        }
        const targetId = $this.attr("id");
        const $mathsParent = $('[data-input-id="' + targetId + '"]');
        const answerSpan = $mathsParent.find(".math-input")[0];
        if ($(answerSpan).is(".mq-math-mode")) {
          return;
        }
        const answerMathField = MQ.MathField(answerSpan, {
          handlers: {
            edit: function () {
              $this.val(answerMathField.latex());
            },
          },
        });
        answerMathFields.push(answerMathField);

        // Hide the drupal input if there is math keypad.
        if ($mathsParent.length > 0) {
          $this.closest("fieldset").hide();
        }

        // If the hidden Drupal field has a value, build the Latex input.
        // This will work for review pages for students or teachers reviewing the
        // questions.
        if (
          $this.closest(".quiz-result-answer").length > 0 &&
          $this.closest("form").is(".form--english")
        ) {
          const formattedText = $this.attr("value").split(" ").join("\\ ");
          answerMathField.write(formattedText);
        } else if ($this.parent().find(">.sr-only").length > 0) {
          const text = $this.parent().find(">.sr-only").text();
          const formattedText = text.split("\\ ").join("");
          answerMathField.write(formattedText);
        } else if ($this.val() !== "") {
          answerMathField.write($this.val());
        }
      });

      // Add new math operation on click.
      $("body").on("click", ".latex-answer-buttons__button", function (e) {
        e.preventDefault();
        const $this = $(e.currentTarget);
        const $parent = $this.closest(".latex-answer__container");
        const key = $parent.index();

        if (answerMathFields[key]) {
          answerMathFields[key].write($this.attr("data-symbol")).focus();
        }
        $parent
          .find(".latex-answer-buttons")
          .toggleClass("latex-answer-buttons--open");
      });

      // Toggle the modal.
      const $mathInput = $(".math-input-button", context).once(
        "math-input-init"
      );
      $mathInput.on("click", function (e) {
        e.preventDefault();
        const $target = $(e.currentTarget);
        const $parent = $target.closest(".latex-answer__container");
        const $buttons = $parent.find(".latex-answer-buttons");

        if ($buttons.length) {
          $buttons.toggleClass("latex-answer-buttons--open");

          // Add an event listener for clicks outside the container
          const handleOutsideClick = (event) => {
            if (!$(event.target).closest(".latex-answer__container").length) {
              $buttons.removeClass("latex-answer-buttons--open");
              $(document).off("click.mathInput", handleOutsideClick);
            }
          };

          $(document).on("click.mathInput", handleOutsideClick);
        }
      });
    },
  };
})(jQuery, Drupal);
